import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import { Observable, Subscription, shareReplay, Subject, forkJoin, interval } from 'rxjs';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { User } from '../../core/classes/user';
import { environment } from '../../../environments/environment';
import { AppConfigService } from '../../app-config.service';
import { loadMessages, locale } from 'devextreme/localization';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { StartService } from 'src/app/core/services/start-service.service';
import { AccreditedRoleService } from 'src/app/core/services/accredited-role.service';
import { registerLocaleData } from '@angular/common';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import localeRu from '@angular/common/locales/ru-BY';
import localeEn from '@angular/common/locales/en-GB';
import { CookieService } from 'ngx-cookie-service';
import { filter, takeUntil } from 'rxjs/operators';
import { IDataForFront, ApiDataSection } from '../../core/interfaces';
import { Store } from '@ngrx/store';
import { selectApiDataSections } from '../../core/store/api-data';
import { formatTime } from './../../shared/helpers'
import { SECONDS_IN_DAY } from 'src/app/constants';

type MenuType = 'catalog' | 'sessions' | 'offers' | 'about' | null;
type SubMenuType = 'offersList' | 'archive' | 'sessionsNts' | null;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  userInfoDropdown: boolean = false;

  // условия для Ролей
  authorized: boolean;
  isTrader: boolean;
  user: User;
  language: any = [
    { name: 'РУС', value: 'RU' },
    { name: 'EN', value: 'EN' },
  ];
  selectLang: string;

  cookieService = inject(CookieService);

  private env: any = environment;
  @ViewChild('account') account: ElementRef;
  @ViewChild('catalog') catalog: ElementRef;
  @ViewChild('session') session: ElementRef;
  @ViewChild('subsession') subsession: ElementRef;
  @ViewChild('offers') offers: ElementRef;
  @ViewChild('suboffers') suboffers: ElementRef;
  @ViewChild('subArchive') subArchive: ElementRef;

  phonesActive: boolean;
  // часы
  time: any;
  locale: string;
  str: string;

  public today: Date = new Date();
  public formattedDate: string;
  public totalSeconds: number;
  public formattedTime: string;
  public sections$: Observable<ApiDataSection[]>;

  isAccredited: boolean = false;

  public strSessionShedule: string;
  public strSessions: string;
  public strSessionsTemplate: string;
  public strModels: string;
  public strRules: string;
  public strAuctions: string;
  public strArchive: string;
  public strReportDeals: string;
  public strReportTrading: string;
  public strReportBiddingProcess: string;

  DemandOfferManagementGetPrivilegus: boolean = false; //привилегия отображения рапсисания сессий
  DemandOfferManagementEditPrivilegus: boolean = false;

  CompositeSesManNewPrivilegus: boolean = false; //привилегия отображения Управ.сессиями (нтс)
  CompositeSesManPrivilegus: boolean = false; //привилегия отображения Управ.сессиями (старое)

  DemandOfferManagementModelsGetPrivilegus: boolean = false; //привилегия отображения конструктора моделей
  DemandOfferManagementModelsEditPrivilegus: boolean = false;

  DemandOfferManagementRulesGetPrivilegus: boolean = false; //привилегия отображения конструктора правил
  DemandOfferManagementRulesEditPrivilegus: boolean = false;

  CompositeAdmissionPrivilegus: boolean = false;

  private translateSub: Subscription;

  activeMenu: MenuType = null;
  activeSubMenu: SubMenuType = null;

  private destroy$ = new Subject<void>();

  constructor(
    public translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private config: AppConfigService,
    private startService: StartService,
    private store: Store,
    private http: HttpClient,
    private readonly accreditedRoleService: AccreditedRoleService
  ) {
    translate.use(JSON.parse(localStorage?.getItem('lang')) || 'RU');

    this.locale = this.translate.currentLang;
    this.selectLang = this.language.find(
      (el: any) => el.value == this.locale
    ).name;

    if (JSON.parse(localStorage.getItem('lang')) === null) {
      localStorage.setItem(
        'lang',
        JSON.stringify(this.translate.defaultLang.toUpperCase())
      );
    }

    //this.cookieService.set('UasLang', this.locale.toUpperCase(), 24, "/")
    // don't forget to unsubscribe!
    this.translateSub = this.translate.onLangChange.subscribe(
      (langChangeEvent: LangChangeEvent) => {
        this.locale = langChangeEvent.lang;
      }
    );

    this.setServerTime();

    //для перевода времени
    registerLocaleData(localeRu);
    registerLocaleData(localeEn);

    locale(this.locale.toLowerCase());

    const cookieToken = this.cookieService.get('UasToken');

    this.user = JSON.parse(localStorage.getItem('user') || '{}');

    if (this.user.token !== cookieToken) {
      this.user.token = cookieToken;

      localStorage.setItem('user', JSON.stringify(this.user));
    }
    this.authorized = !!this.user.token;

    if (this.authorized) {
      forkJoin([
        this.startService.hasWorkerRole(this.user.token),
        this.startService.getDataForFront(this.user.token)
      ]).subscribe(([isWorker, res]: [boolean, IDataForFront]) => {

        this.user.IsWorker = isWorker;

        this.user.userInfo = {
          firmName: res.headerInfo.nameFirm,
          traderFullName: res.headerInfo.fio,
          traderPhone: res.headerInfo.traderPhone,
          traderRegNum: res.headerInfo.regNumberTrader,
          validTo: res.headerInfo.validTo,
        };

        localStorage.setItem(
          'privileges',
          JSON.stringify(res.privileges.privilegesList)
        );

        this.UserSetItem();

        if (this.user.IsWorker) {
          this.checkPrivilegus();
        }
      });

      const UASLang = this.cookieService.get('UasLang');
      if (UASLang && this.locale != UASLang) {
        localStorage.setItem(
          'lang',
          JSON.stringify(UASLang.toString().toUpperCase())
        );
        translate.use(UASLang.toString().toUpperCase());
        this.locale = UASLang.toString();
        this.selectLang = this.language.find(
          (el) => el.value == this.locale
        ).name;
        locale(this.locale.toLowerCase());
        parent.document.location.reload();
      }

      if (!this.cookieService.get('UasLang')) {
        this.cookieService.set('UasLang', this.locale.toUpperCase(), 24, '/');
      }

    } else {
      this.user.IsWorker = false;
      this.UserSetItem();
      this.cookieService.set('UasLang', this.locale.toUpperCase(), 24, '/');
    }
  }

  public setServerTime(): void {
    this.startService.getServerDatetime().subscribe((res: number) => {
      this.totalSeconds = Math.floor(res * SECONDS_IN_DAY);
      this.formattedTime = formatTime(this.totalSeconds);
    });

    const datePart: string = this.today.toLocaleDateString(this.locale, {
      timeZone: 'Europe/Minsk',
      day: 'numeric',
      month: 'long'
    });

    const weekdayPart: string = this.today.toLocaleDateString(this.locale, {
      timeZone: 'Europe/Minsk',
      weekday: 'short'
    });

    this.formattedDate = `${datePart}, ${weekdayPart}`;

    interval(1000)
    .pipe(takeUntil(this.destroy$))
    .subscribe(() => {
      if (this.totalSeconds > 0) {
        this.totalSeconds += 1;
        this.formattedTime = formatTime(this.totalSeconds);
      }
    });
  }

  UserSetItem() {
    localStorage.setItem('user', JSON.stringify(this.user));
    if (location.search.split('return').length > 1) {
      //  this.cookieService.delete('return')
      window.location.href = location.pathname;
      sessionStorage.clear();
    }
  }

  GetRole(SessionKey) {
    const myHeaders = new HttpHeaders().set('Authorization', SessionKey);
    return this.http
      .get(`${this.config.backendINV}${this.config.OrderManagement}/Auth/GetRole`, {
        headers: myHeaders,
      })
      .pipe(shareReplay(1))
      .toPromise();
  }

  toggleMenu(menu: MenuType) {
    this.activeMenu = this.activeMenu === menu ? null : menu;
    this.activeSubMenu = null;
  }

  toggleSubMenu(menu: SubMenuType) {
    this.activeSubMenu = this.activeSubMenu === menu ? null : menu;
  }

  closeMenus() {
    this.activeMenu = null;
    this.activeSubMenu = null;
  }

  @HostListener('document:click')
  onOutsideClick() {
    this.closeMenus();
  }

  ngOnInit(): void {
    loadMessages(ruMessages);
    this.sections$ = this.store.select(selectApiDataSections);

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        // Only close if a menu is actually open
        if (this.activeMenu !== null) {
          this.closeMenus();
        }
      });

    if (this.user?.token) {
      this.GetRole(this.user?.token).then((res: any) => {
        this.isAccredited = !!parseInt(res.role, 10);
        this.accreditedRoleService.setRole(res.role);
      });
    }

    this.strSessionShedule = `${this.config.host}${this.config.orderMan}sessions-schedule`;
    this.strSessions = `${this.config.host}${this.config.sessions}/sessions/management#schedule`;
    this.strSessionsTemplate = `${this.config.host}${this.config.sessions}/sessions/management#templates`;
    this.strModels = `${this.config.host}${this.config.sessions}/demands/management#models`;
    this.strRules = `${this.config.host}${this.config.sessions}/demands/management#rules`;
    this.strAuctions = `${this.config.host}${this.config.auctions}`;
    this.strArchive = `${this.config.host}${this.config.orderMan}unrealizedVolumes`;
    this.strReportDeals = `${this.config.host}${this.config.orderMan}report-deals`;
    this.strReportTrading = `${this.config.host}${this.config.orderMan}report-trading-session-orders`;
    this.strReportBiddingProcess = `${this.config.host}${this.config.orderMan}report-bidding-process`;
  }

  public checkPrivilegus(): void {
    let DemandOfferManagementGetDesc = 'DemandOfferManagementGetList';
    this.DemandOfferManagementGetPrivilegus = this.startService.checkPrivileges(
      DemandOfferManagementGetDesc
    );
    let DemandOfferManagementEditDesc = 'DemandOfferManagementEditItem';
    this.DemandOfferManagementEditPrivilegus =
      this.startService.checkPrivileges(DemandOfferManagementEditDesc);
    let CompositeSesManNewDesc = 'CompositeSessionsManagementNew';
    this.CompositeSesManNewPrivilegus = this.startService.checkPrivileges(
      CompositeSesManNewDesc
    );
    let CompositeSesManDesc = 'CompositeSessionsManagement';
    this.CompositeSesManPrivilegus =
      this.startService.checkPrivileges(CompositeSesManDesc);
    let DemandOfferManagementModelsGetDesc =
      'DemandOfferManagementModelsGetList';
    this.DemandOfferManagementModelsGetPrivilegus =
      this.startService.checkPrivileges(DemandOfferManagementModelsGetDesc);
    let DemandOfferManagementModelsEditDesc =
      'DemandOfferManagementModelsEditItem';
    this.DemandOfferManagementModelsEditPrivilegus =
      this.startService.checkPrivileges(DemandOfferManagementModelsEditDesc);
    let DemandOfferManagementRulesGetDesc = 'DemandOfferManagementRulesGetList';
    this.DemandOfferManagementRulesGetPrivilegus =
      this.startService.checkPrivileges(DemandOfferManagementRulesGetDesc);
    let DemandOfferManagementRulesEditDesc =
      'DemandOfferManagementRulesEditItem';
    this.DemandOfferManagementRulesEditPrivilegus =
      this.startService.checkPrivileges(DemandOfferManagementRulesEditDesc);
    let CompositeAdmissionDesc = 'CompositeAdmission';
    this.CompositeAdmissionPrivilegus = this.startService.checkPrivileges(
      CompositeAdmissionDesc
    );
  }

  isAcceptableRole() {
    return this.accreditedRoleService.getRole() != "0"
  }

  switchLang(event: any, lang: string) {
    localStorage.setItem('lang', JSON.stringify(lang.toUpperCase()));
    locale(lang.toLowerCase());
    parent.document.location.reload();
  }

  changeLang(e: any) {
    this.selectLang = e.itemData.name;
    const lang = e.itemData.value;
    this.translate.use(lang.toUpperCase());
    localStorage.setItem('lang', JSON.stringify(lang.toUpperCase()));
    this.cookieService.set('UasLang', lang.toUpperCase(), 24, '/');

    sessionStorage.setItem('BUTBlang', JSON.stringify(lang.toUpperCase()));
    // document.cookie = 'BUTBlang=' + lang + ';samesite=Lax';
    if (this.user?.token) {
      const body = {
        language: lang,
      };

      this.startService
        .SetPreferredLanguage(this.user?.token, body)
        .then((res: any) => {
          locale(lang);
          parent.document.location.reload();
        });
    } else {
      locale(lang);
      parent.document.location.reload();
    }
  }

  // goToSessionsSchedule() {
  //   //  const str = `${this.config.orderMan}/sessions-schedule`;
  //   console.log(this.strSessionShedule);
  //   window.location.href = this.strSessionShedule;
  // }

  getMainUrl(){
    return `${this.config.host}landingpage`;
  }

  goToMain(event: MouseEvent) {
    if (event.ctrlKey || event.metaKey || event.button === 1) {
      return;
    }

    event.preventDefault();
    this.router
      .navigate([`/`], { skipLocationChange: true })
      .then(() => (window.location.href = '/landingpage'));
  }

  goToSessions() {
    window.location.href = this.strSessions;
  }

  goToSessionsTemplates() {
    window.location.href = this.strSessionsTemplate;
  }

  goToModels() {
    const str = `${this.config.host}${this.config.sessions}demands/management#models`;
    window.location.href = str; // + "?jwt=" + this.user?.token;
  }

  goToRules() {
    const str = `${this.config.host}${this.config.sessions}demands/management#rules`;
    window.location.href = str; // + "?jwt=" + this.user?.token;
  }

  goToAuctions() {
    const str = `${this.config.host}${this.config.auctions}`;
    window.location.href = str; // + "?jwt=" + this.user?.token;
  }

  getCatalogUrl(type: number): string {
    return `${this.config.host}${this.config.orderMan}/catalog?direction=${type}`;
  }

  getPersonalPageIndexUrl() {
    return `${this.config.ppRedirectUrl}` +
      '?jwt=' + this.user?.token +
      '&page=index&lang=' + this.cookieService.get('UasLang');
  }

  getPersonalPageCatalogueUrl() {
    return (
      `${this.config.ppRedirectUrl}` +
      '?jwt=' + this.user?.token +
      '&page=catalogue&lang=' + this.cookieService.get('UasLang'));
  }

  getPersonalPageAdmissionUrl() {
    return (
      `${this.config.ppRedirectUrl}` +
      '?jwt=' + this.user?.token +
      '&page=admission&lang=' + this.cookieService.get('UasLang')
    );
  }

  getPersonalPageSessionManageUrl() {
    return `${this.config.ppRedirectUrl}` +
      '?jwt=' + this.user?.token +
      '&page=session&lang=' + this.cookieService.get('UasLang');
  }

  public getOffersManagementUrl(sectionId: string): string {
    return `${this.config.host}${this.config.orderMan}/offer-management?idSection=${sectionId}&type=current`;
  }

  public handleOfferClick(event: MouseEvent, sectionId: string): void {

    event.stopPropagation();
    const offerSection = {
      sectionId,
      type: 'current'
    };

    localStorage.setItem('offerSection', JSON.stringify(offerSection) );
  }

  getLocation(path) {
    return window.location.pathname.includes(path);
  }

  getReportArchiveUrl() {
    return this.strArchive;
  }

  getReportDealsUrl() {
    return this.strReportDeals;
  }

  getReportTradingUrl() {
    return this.strReportTrading;
  }

  get getPersonalPageNotifyingUrl(): string{

    return (`${this.config.ppRedirectUrl}` +
      '?jwt=' + this.user?.token +
      '&page=notification&lang=' + this.cookieService.get('UasLang')
    )
  }

  loginUAS() {
    if (!this.authorized) {
      const lang = this.cookieService.get('UasLang').toLowerCase();
      const returnurl = document.location.href.replace(/\//g, '%2F');
      const encodedReturnUrl = encodeURIComponent(returnurl);

      const str = `${this.config.uas_front}/ppts/false/${lang}/token;returnUrl=${encodedReturnUrl};errorUrl=null`;
      window.location.href = str;
    } else {
      this.userInfoDropdown = !this.userInfoDropdown;
    }
  }

  logOut() {
    this.authorized = false;
    this.userInfoDropdown = false;
    this.startService.logOut(this.user?.token).subscribe(() => {
      this.cookieService.delete('UasToken', '/');
      this.cookieService.delete('UasMessage', '/');
      // this.cookieService.delete('UasLang', '/')
      localStorage.removeItem('user');
      this.router.navigate(['/']).then(() => location.reload());
    });
  }

  ngOnDestroy() {
    this.translateSub.unsubscribe();
  }
}
